<template>
  <section class="card">
    <h2 class="section-heading">
      {{ t('sectionB.title') }}
    </h2>
    <div class="mt-3">
      <div class="head-block">
        <label class="question-title">
          {{ t('sectionB.nervous.title') }}
          <span class="title-help-text">
            ({{t('common.ifYesPleaseChooseOne')}})
          </span>
        </label>
        <YesNoToggle
          v-model="form.nervous.hasCondition"
          name="nervous-condition"
          :yes-label="t('common.yes')"
          :no-label="t('common.no')"
          class="my-2"
          :class="{ 'is-invalid': formErrors.has('sectionB.nervous.hasCondition') }"
          @change="onYesNoChange('nervous')"
        />
      </div>
      <p
        v-if="formErrors.has('sectionB.nervous.hasCondition')"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.nervous.hasCondition')) }}
      </p>
      <div 
        class="checkbox-grid"
        v-if="form.nervous.hasCondition !== 'no'"
        :class="{ 'is-invalid': formErrors.has('sectionB.nervous.conditions') }"
      >
        <label class="checkbox-card" v-for="condition in nervousConditions"
        :key="condition.value">
          <input
            type="checkbox"
            :value="condition.value"
            v-model="form.nervous.conditions"
            @change="onConditionChange('nervous')"

          />
          <span>{{ t(condition.label) }}</span>
        </label>
      </div>
      <p
        v-if="formErrors.has('sectionB.nervous.conditions') && form.nervous.hasCondition ==='yes'"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.nervous.conditions')) }}
      </p>
    </div>
    <div class="mt-3">
      <div class="head-block">
        <label class="question-title">
          {{ t('sectionB.heart.title') }}
          <span class="title-help-text">
            ({{t('common.ifYesPleaseChooseOne')}})
          </span>
        </label>
        <YesNoToggle
          v-model="form.heart.hasCondition"
          name="heart-condition"
          :yes-label="t('common.yes')"
          :no-label="t('common.no')"
          class="my-2"
          :class="{ 'is-invalid': formErrors.has('sectionB.heart.hasCondition') }"
          @change="onYesNoChange('heart')"
        />
      </div>
      <p
        v-if="formErrors.has('sectionB.heart.hasCondition')"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.heart.hasCondition')) }}
      </p>
      <div 
        class="checkbox-grid"
        v-if="form.heart.hasCondition !== 'no'"
        :class="{ 'is-invalid': formErrors.has('sectionB.heart.conditions') }"
      >
        <label class="checkbox-card" v-for="condition in heartConditions"
        :key="condition.value">
          <input
            type="checkbox"
            :value="condition.value"
            v-model="form.heart.conditions"
            @change="onConditionChange('heart')"
          />
          <span>{{ t(condition.label) }}</span>
        </label>
      </div>
      <p
        v-if="formErrors.has('sectionB.heart.conditions') && form.heart.hasCondition ==='yes'"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.heart.conditions')) }}
      </p>
    </div>
    <div class="mt-3">
      <div class="head-block">
        <label class="question-title">
          {{ t('sectionB.bloodVessel.title') }}
          <span class="title-help-text">
            ({{t('common.ifYesPleaseChooseOne')}})
          </span>
        </label>
        <YesNoToggle
          v-model="form.bloodVessel.hasCondition"
          name="bloodVessel-condition"
          :yes-label="t('common.yes')"
          :no-label="t('common.no')"
          class="my-2"
          :class="{ 'is-invalid': formErrors.has('sectionB.bloodVessel.hasCondition') }"
          @change="onYesNoChange('bloodVessel')"
        />
      </div>
      <p
        v-if="formErrors.has('sectionB.bloodVessel.hasCondition')"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.bloodVessel.hasCondition')) }}
      </p>
      <div 
        class="checkbox-grid"
        v-if="form.bloodVessel.hasCondition !== 'no'"
        :class="{ 'is-invalid': formErrors.has('sectionB.bloodVessel.conditions') }"
        >
        <label class="checkbox-card" v-for="condition in bloodVesselConditions"
        :key="condition.value">
          <input
            type="checkbox"
            :value="condition.value"
            v-model="form.bloodVessel.conditions"
            @change="onConditionChange('bloodVessel')"
          />
          <span>{{ t(condition.label) }}</span>
        </label>
      </div>
      <p 
        v-if="formErrors.has('sectionB.bloodVessel.conditions') && form.bloodVessel.hasCondition ==='yes'"
        class="error-text">
        {{ t(formErrors.first('sectionB.bloodVessel.conditions')) }}
      </p>
    </div>
    <div class="mt-3">
      <div class="head-block">
        <label class="question-title">
          {{ t('sectionB.metabolic.title') }}
          <span class="title-help-text">
            ({{ t('common.ifYesPleaseChooseOne') }})
          </span>
        </label>

        <YesNoToggle
          v-model="form.metabolic.hasCondition"
          name="metabolic-condition"
          :yes-label="t('common.yes')"
          :no-label="t('common.no')"
          class="my-2"
          :class="{ 'is-invalid': formErrors.has('sectionB.metabolic.hasCondition') }"
          @change="onYesNoChange('metabolic')"
        />
      </div>
      <p
        v-if="formErrors.has('sectionB.metabolic.hasCondition')"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.metabolic.hasCondition')) }}
      </p>

      <div
        class="checkbox-grid"
        v-if="form.metabolic.hasCondition !== 'no'"
        :class="{ 'is-invalid': formErrors.has('sectionB.metabolic.conditions') }"
      >
        <label
          class="checkbox-card"
          v-for="condition in metabolicConditions"
          :key="condition.value"
        >
          <input
            type="checkbox"
            :value="condition.value"
            v-model="form.metabolic.conditions"
            @change="onConditionChange('metabolic')"
          />
          <span>{{ t(condition.label) }}</span>
        </label>
      </div>

      <p 
        v-if="formErrors.has('sectionB.metabolic.conditions') && form.metabolic.hasCondition ==='yes'" 
        class="error-text">
        {{ t(formErrors.first('sectionB.metabolic.conditions')) }}
      </p>
    </div>

    <div class="mt-3">
      <div class="head-block">
        <label class="question-title">
          {{ t('sectionB.respiratory.title') }}
          <span class="title-help-text">
            ({{ t('common.ifYesPleaseChooseOne') }})
          </span>
        </label>

        <YesNoToggle
          v-model="form.respiratory.hasCondition"
          name="respiratory-condition"
          :yes-label="t('common.yes')"
          :no-label="t('common.no')"
          class="my-2"
          :class="{ 'is-invalid': formErrors.has('sectionB.respiratory.hasCondition') }"
          @change="onYesNoChange('respiratory')"
        />
      </div>
      <p
        v-if="formErrors.has('sectionB.respiratory.hasCondition')"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.respiratory.hasCondition')) }}
      </p>

      <div
        class="checkbox-grid"
        v-if="form.respiratory.hasCondition !== 'no'"
        :class="{ 'is-invalid': formErrors.has('sectionB.respiratory.conditions') }"
      >
        <label
          class="checkbox-card"
          v-for="condition in respiratoryConditions"
          :key="condition.value"
        >
          <input
            type="checkbox"
            :value="condition.value"
            v-model="form.respiratory.conditions"
            @change="onConditionChange('respiratory')"
          />
          <span>{{ t(condition.label) }}</span>
        </label>
      </div>

      <p 
        v-if="formErrors.has('sectionB.respiratory.conditions') && form.respiratory.hasCondition ==='yes'" 
        class="error-text">
        {{ t(formErrors.first('sectionB.respiratory.conditions')) }}
      </p>
    </div>

    <div class="mt-3">
      <div class="head-block">
        <label class="question-title">
          {{ t('sectionB.digestive.title') }}
          <span class="title-help-text">
            ({{t('common.ifYesPleaseChooseOne')}})
          </span>
        </label>
        <YesNoToggle
          v-model="form.digestive.hasCondition"
          name="digestive-condition"
          :yes-label="t('common.yes')"
          :no-label="t('common.no')"
          class="my-2"
          :class="{ 'is-invalid': formErrors.has('sectionB.digestive.hasCondition') }"
          @change="onYesNoChange('digestive')"
        />
      </div>
      <p
        v-if="formErrors.has('sectionB.digestive.hasCondition')"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.digestive.hasCondition')) }}
      </p>
      <div 
        class="checkbox-grid"
        v-if="form.digestive.hasCondition !== 'no'"
        :class="{ 'is-invalid': formErrors.has('sectionB.digestive.conditions') }"
        >
        <label class="checkbox-card" v-for="condition in digestiveConditions" :key="condition.value">
          <input
            type="checkbox"
            :value="condition.value"
            v-model="form.digestive.conditions"
            @change="onConditionChange('digestive')"
          />
          <span>{{ t(condition.label) }}</span>
        </label>
      </div>
      <p
        v-if="formErrors.has('sectionB.digestive.conditions') && form.digestive.hasCondition ==='yes'"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.digestive.conditions')) }}
      </p>
    </div>
    <div class="mt-3">
      <div class="head-block">
        <label class="question-title">
          {{ t('sectionB.liver.title') }}
          <span class="title-help-text">
            ({{t('common.ifYesPleaseChooseOne')}})
          </span>
        </label>
        <YesNoToggle
          v-model="form.liver.hasCondition"
          name="liver-condition"
          :yes-label="t('common.yes')"
          :no-label="t('common.no')"
          class="my-2"
          :class="{ 'is-invalid': formErrors.has('sectionB.liver.hasCondition') }"
          @change="onYesNoChange('liver')"
        />
      </div>
      <p
        v-if="formErrors.has('sectionB.liver.hasCondition')"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.liver.hasCondition')) }}
      </p>
      <div 
        class="checkbox-grid"
        v-if="form.liver.hasCondition !== 'no'"
        :class="{ 'is-invalid': formErrors.has('sectionB.liver.conditions') }"
        >
        <label class="checkbox-card" v-for="condition in liverConditions" :key="condition.value">
          <input
            type="checkbox"
            :value="condition.value"
            v-model="form.liver.conditions"
            @change="onConditionChange('liver')"
          />
          <span>{{ t(condition.label) }}</span>
        </label>
      </div>
      <p
        v-if="formErrors.has('sectionB.liver.conditions') && form.liver.hasCondition ==='yes'"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.liver.conditions')) }}
      </p>
    </div>
    <div class="mt-3">
      <div class="head-block">
        <label class="question-title">
          {{ t('sectionB.hernia.title') }}
          <span class="title-help-text">
            ({{t('common.ifYesPleaseChooseOne')}})
          </span>
        </label>
        <YesNoToggle
          v-model="form.hernia.hasCondition"
          name="hernia-condition"
          :yes-label="t('common.yes')"
          :no-label="t('common.no')"
          class="my-2"
          :class="{ 'is-invalid': formErrors.has('sectionB.hernia.hasCondition') }"
          @change="onYesNoChange('hernia')"
        />
      </div>
      <p
        v-if="formErrors.has('sectionB.hernia.hasCondition')"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.hernia.hasCondition')) }}
      </p>
      <div 
        class="checkbox-grid"
        v-if="form.hernia.hasCondition !== 'no'"
        :class="{ 'is-invalid': formErrors.has('sectionB.hernia.conditions') }"
      >
        <label class="checkbox-card" v-for="condition in herniaConditions" :key="condition.value">
          <input
            type="checkbox"
            :value="condition.value"
            v-model="form.hernia.conditions"
            @change="onConditionChange('hernia')"
          />
          <span>{{ t(condition.label) }}</span>
        </label>
      </div>
      <p
        v-if="formErrors.has('sectionB.hernia.conditions') && form.hernia.hasCondition ==='yes'"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.hernia.conditions')) }}
      </p>
    </div>
    <div class="mt-3">
      <div class="head-block">
        <label class="question-title">
          {{ t('sectionB.kidneyUrinary.title') }}
          <span class="title-help-text">
            ({{t('common.ifYesPleaseChooseOne')}})
          </span>
        </label>
        <YesNoToggle
          v-model="form.kidneyUrinary.hasCondition"
          name="kidney-condition"
          :yes-label="t('common.yes')"
          :no-label="t('common.no')"
          class="my-2"
          :class="{ 'is-invalid': formErrors.has('sectionB.kidneyUrinary.hasCondition') }"
          @change="onYesNoChange('kidneyUrinary')"
        />
      </div>
      <p
        v-if="formErrors.has('sectionB.kidneyUrinary.hasCondition')"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.kidneyUrinary.hasCondition')) }}
      </p>
      <div 
        class="checkbox-grid"
        v-if="form.kidneyUrinary.hasCondition !== 'no'"
        :class="{ 'is-invalid': formErrors.has('sectionB.kidneyUrinary.conditions') }"
      >
        <label class="checkbox-card" v-for="condition in kidneyUrinaryConditions" :key="condition.value">
          <input
            type="checkbox"
            :value="condition.value"
            v-model="form.kidneyUrinary.conditions"
            @change="onConditionChange('kidneyUrinary')"
          />
          <span>{{ t(condition.label) }}</span>
        </label>
      </div>
      <p
        v-if="formErrors.has('sectionB.kidneyUrinary.conditions') && form.kidneyUrinary.hasCondition ==='yes'"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.kidneyUrinary.conditions')) }}
      </p>
    </div>
    <div class="mt-3">
      <div class="head-block">
        <label class="question-title">
          {{ t('sectionB.jointsBones.title') }}
          <span class="title-help-text">
            ({{t('common.ifYesPleaseChooseOne')}})
          </span>
        </label>
        <YesNoToggle
          v-model="form.jointsBones.hasCondition"
          name="jointsBones-condition"
          :yes-label="t('common.yes')"
          :no-label="t('common.no')"
          class="my-2"
          :class="{ 'is-invalid': formErrors.has('sectionB.jointsBones.hasCondition') }"
          @change="onYesNoChange('jointsBones')"
        />
      </div>
      <p
        v-if="formErrors.has('sectionB.jointsBones.hasCondition')"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.jointsBones.hasCondition')) }}
      </p>
      <div 
        class="checkbox-grid"
        v-if="form.jointsBones.hasCondition !== 'no'"
        :class="{ 'is-invalid': formErrors.has('sectionB.jointsBones.conditions') }"
      >
        <label class="checkbox-card" v-for="condition in jointsBonesConditions" :key="condition.value">
          <input
            type="checkbox"
            :value="condition.value"
            v-model="form.jointsBones.conditions"
            @change="onConditionChange('jointsBones')"
          />
          <span>{{ t(condition.label) }}</span>
        </label>
      </div>
      <p
        v-if="formErrors.has('sectionB.jointsBones.conditions') && form.jointsBones.hasCondition ==='yes'"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.jointsBones.conditions')) }}
      </p>
    </div>
    <div class="mt-3">
      <div class="head-block">
        <label class="question-title">
          {{ t('sectionB.skinSex.title') }}
          <span class="title-help-text">
            ({{t('common.ifYesPleaseChooseOne')}})
          </span>
        </label>
        <YesNoToggle
          v-model="form.skinSex.hasCondition"
          name="skinSex-condition"
          :yes-label="t('common.yes')"
          :no-label="t('common.no')"
          class="my-2"
          :class="{ 'is-invalid': formErrors.has('sectionB.skinSex.hasCondition') }"
          @change="onYesNoChange('skinSex')"
        />
      </div>
      <p
        v-if="formErrors.has('sectionB.skinSex.hasCondition')"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.skinSex.hasCondition')) }}
      </p>
      <div 
        class="checkbox-grid"
        v-if="form.skinSex.hasCondition !== 'no'"
        :class="{ 'is-invalid': formErrors.has('sectionB.skinSex.conditions') }"
      >
        <label class="checkbox-card" v-for="condition in skinSexConditions" :key="condition.value">
          <input
            type="checkbox"
            :value="condition.value"
            v-model="form.skinSex.conditions"
            @change="onConditionChange('skinSex')"
          />
          <span>{{ t(condition.label) }}</span>
        </label>
      </div>
      <p
        v-if="formErrors.has('sectionB.skinSex.conditions') && form.skinSex.hasCondition ==='yes'"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.skinSex.conditions')) }}
      </p>
    </div>
    <div class="mt-3">
      <div class="head-block">
        <label class="question-title">
          {{ t('sectionB.malignant.title') }}
        </label>
        <YesNoToggle
          v-model="form.malignant.hasCondition"
          name="malignant-condition"
          :yes-label="t('common.yes')"
          :no-label="t('common.no')"
          class="my-2"
          :class="{ 'is-invalid': formErrors.has('sectionB.malignant.hasCondition') }"
          @change="onYesNoChange('malignant')"
        />
      </div>
      <p
        v-if="formErrors.has('sectionB.malignant.hasCondition')"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.malignant.hasCondition')) }}
      </p>
    </div>
    <div class="mt-3">
      <div class="head-block">
        <label class="question-title">
          {{ t('sectionB.ent.title') }}
          <span class="title-help-text">
            ({{t('common.ifYesPleaseChooseOne')}})
          </span>
        </label>
        <YesNoToggle
          v-model="form.ent.hasCondition"
          name="ent-condition"
          :yes-label="t('common.yes')"
          :no-label="t('common.no')"
          class="my-2"
          :class="{ 'is-invalid': formErrors.has('sectionB.ent.hasCondition') }"
          @change="onYesNoChange('ent')"
        />
      </div>
      <p
        v-if="formErrors.has('sectionB.ent.hasCondition')"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.ent.hasCondition')) }}
      </p>
      <div 
        class="checkbox-grid"
        v-if="form.ent.hasCondition !== 'no'"
        :class="{ 'is-invalid': formErrors.has('sectionB.ent.conditions') }"
      >
        <label class="checkbox-card" v-for="condition in entConditions" :key="condition.value">
          <input
            type="checkbox"
            :value="condition.value"
            v-model="form.ent.conditions"
            @change="onConditionChange('ent')"
          />
          <span>{{ t(condition.label) }}</span>
        </label>
      </div>
      <p
        v-if="formErrors.has('sectionB.ent.conditions') && form.ent.hasCondition ==='yes'"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.ent.conditions')) }}
      </p>
    </div>
    <div class="mt-3" v-if="gender">
      <div class="head-block">
        <label class="question-title">
          {{ gender=='male' ?t('sectionB.men.title'): t('sectionB.women.title')}}
          <span class="title-help-text">
            ({{t('common.ifYesPleaseChooseOne')}})
          </span>
        </label>
        <YesNoToggle
          v-model="form.genderCondition.hasCondition"
          name="women-condition"
          :yes-label="t('common.yes')"
          :no-label="t('common.no')"
          class="my-2"
          :class="{ 'is-invalid': formErrors.has('sectionB.genderCondition.hasCondition') }"
          @change="onYesNoChange('genderCondition')"
        />
      </div>
      <p
        v-if="formErrors.has('sectionB.genderCondition.hasCondition')"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.genderCondition.hasCondition')) }}
      </p>
      <div 
        class="checkbox-grid"
        v-if="form.genderCondition.hasCondition !== 'no'"
        :class="{ 'is-invalid': formErrors.has('sectionB.genderCondition.conditions') }"
      >
        <label class="checkbox-card" v-for="condition in genderConditions" :key="condition.value">
          <input
            type="checkbox"
            :value="condition.value"
            v-model="form.genderCondition.conditions"
            @change="onConditionChange('genderCondition')"
          />
          <span>{{ t(condition.label) }}</span>
        </label>
      </div>
      <p
        v-if="formErrors.has('sectionB.genderCondition.conditions') && form.genderCondition.hasCondition ==='yes'"
        class="error-text"
      >
        {{ t(formErrors.first('sectionB.genderCondition.conditions')) }}
      </p>
    </div>
  </section>
</template>
<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n';
import YesNoToggle from '@/components/YesNoToggle.vue';
import { reactive } from 'vue';
import Error from '@/utils/Error';
const { t } = useI18n()

const props = defineProps({ modelValue: {
    type: Object,
    required: true,
  },
  gender:{
    type: String
  },
  formErrors:{
    type:Object,
    required:false,
    default:reactive(new Error({}))
  }
});
const emit = defineEmits(['update:modelValue','removeError']);
const form = reactive({ ...props.modelValue })
watch(form,(newVal) => {
  emit("update:modelValue",newVal);
})
onMounted(()=>{
  // console.log(form.value);
});

const onYesNoChange = (sectionName) => {
  clearError(`sectionB.${sectionName}.hasCondition`);
  if (form[sectionName].hasCondition === 'no') {
    form[sectionName].conditions = [];
    clearError(`sectionB.${sectionName}.conditions`);
  }
}
const clearError = async(name)=>{
	emit("removeError",name)
}

const nervousConditions = [
  { value: 'nervous_system', label: 'sectionB.nervous.nervousSystem' },
  { value: 'cerebrovascular_accident', label: 'sectionB.nervous.cerebrovascularAccident' },
  { value: 'epilepsy', label: 'sectionB.nervous.epilepsy' },
  { value: 'multiple_sclerosis', label: 'sectionB.nervous.multipleSclerosis' },
  { value: 'muscular_dystrophy', label: 'sectionB.nervous.muscularDystrophy' },
  { value: 'dizziness', label: 'sectionB.nervous.dizziness' },
  { value: 'headaches', label: 'sectionB.nervous.headaches' },
  { value: 'balance_disorders', label: 'sectionB.nervous.balanceDisorders' },
  { value: 'fainting', label: 'sectionB.nervous.fainting' },
  { value: 'parkinson', label: 'sectionB.nervous.parkinson' },
  { value: 'alzheimers', label: 'sectionB.nervous.alzheimers' },
  { value: 'trembling', label: 'sectionB.nervous.trembling' },
  { value: 'mental_retardation', label: 'sectionB.nervous.mentalRetardation' },
  { value: 'autism', label: 'sectionB.nervous.autism' },
  { value: 'down_syndrome', label: 'sectionB.nervous.downSyndrome' },
  { value: 'cerebral_palsy', label: 'sectionB.nervous.cerebralPalsy' },
  { value: 'polio', label: 'sectionB.nervous.polio' },
  { value: 'gaucher', label: 'sectionB.nervous.gaucher' },
  { value: 'numbness', label: 'sectionB.nervous.numbness' },
  { value: 'adhd', label: 'sectionB.nervous.adhd' },
  { value: 'migraine', label: 'sectionB.nervous.migraine' },
  { value: 'memory_decline', label: 'sectionB.nervous.memoryDecline' },
  { value: 'aids_hiv', label: 'sectionB.nervous.aidsHiv' },
  { value: 'lupus', label: 'sectionB.nervous.lupus' }
];
const heartConditions = [
  { value: 'cardiac_arrhythmias', label: 'sectionB.heart.cardiacArrhythmias' },
  { value: 'heart_disease', label: 'sectionB.heart.heartDisease' },
  { value: 'heart_failure', label: 'sectionB.heart.heartFailure' },
  { value: 'heart_attack', label: 'sectionB.heart.heartAttack' },
  { value: 'congenital_heart_defect', label: 'sectionB.heart.congenitalHeartDefect' },
  { value: 'catheterization', label: 'sectionB.heart.catheterization' },
  { value: 'heart_valve_diseases', label: 'sectionB.heart.heartValveDiseases' },
  { value: 'other_heart_disease', label: 'sectionB.heart.otherHeartDisease' },
]
const bloodVesselConditions = [
  { value: 'varicose_veins', label: 'sectionB.bloodVessel.varicoseVeins',},
  { value: 'carotid_artery', label: 'sectionB.bloodVessel.carotidArtery', },
  { value: 'coagulation_disorders', label: 'sectionB.bloodVessel.coagulationDisorders', },
  { value: 'blood_disease', label: 'sectionB.bloodVessel.bloodDisease',},
  { value: 'dvt', label: 'sectionB.bloodVessel.dvt',},
  { value: 'pvd', label: 'sectionB.bloodVessel.pvd',},
  { value: 'other_vascular_disease', label: 'sectionB.bloodVessel.otherVascularDisease',},
];
const metabolicConditions = [
  { value: 'thyroid', label: 'sectionB.metabolic.thyroid', },
  { value: 'lymph_node', label: 'sectionB.metabolic.lymphNode', },
  { value: 'salivary_gland', label: 'sectionB.metabolic.salivaryGland', },
  { value: 'pituitary', label: 'sectionB.metabolic.pituitary', },
  { value: 'sweat_gland', label: 'sectionB.metabolic.sweatGland', },
  { value: 'diabetes', label: 'sectionB.metabolic.diabetes', },
  { value: 'hypertension', label: 'sectionB.metabolic.hypertension', },
  { value: 'other_metabolic_disease',label: 'sectionB.metabolic.otherMetaBolicDisease', },
];

const respiratoryConditions = [
  { value: 'asthma', label: 'sectionB.respiratory.asthma', },
  { value: 'tuberculosis', label: 'sectionB.respiratory.tuberculosis', },
  { value: 'hay_fever', label: 'sectionB.respiratory.hayFever', },
  { value: 'copd', label: 'sectionB.respiratory.copd', },
  { value: 'recurrent_infections', label: 'sectionB.respiratory.recurrentInfections', },
  { value: 'shortness_of_breath', label: 'sectionB.respiratory.shortnessOfBreath', },
  { value: 'pneumothorax', label: 'sectionB.respiratory.pneumothorax', },
  { value: 'cystic_fibrosis', label: 'sectionB.respiratory.cysticFibrosis', },
  { value: 'other_respiratory_disease', label: 'sectionB.respiratory.otherRespiratoryDisease', },
];

const digestiveConditions = [
  { value: 'ulcer', label: 'sectionB.digestive.ulcer', },
  { value: 'heartburn', label: 'sectionB.digestive.heartburn', },
  { value: 'crohns', label: 'sectionB.digestive.crohns', },
  { value: 'colitis', label: 'sectionB.digestive.colitis', },
  { value: 'reflux', label: 'sectionB.digestive.reflux', },
  { value: 'hemorrhoids', label: 'sectionB.digestive.hemorrhoids', },
  { value: 'fissure_fistula', label: 'sectionB.digestive.fissureFistula', },
  { value: 'bowel_obstruction', label: 'sectionB.digestive.bowelObstruction', },
  { value: 'pancreatic', label: 'sectionB.digestive.pancreatic', },
  { value: 'esophagus', label: 'sectionB.digestive.esophagus', },
  { value: 'gallbladder', label: 'sectionB.digestive.gallbladder', },
  { value: 'gallstones', label: 'sectionB.digestive.gallstones', },
  { value: 'other_digestive_disease', label: 'sectionB.digestive.otherDigestiveDisease', },
];
const liverConditions = [
  { value: 'jaundice', label: 'sectionB.liver.jaundice', },
  { value: 'hepatitis_b', label: 'sectionB.liver.hepatitisB', },
  { value: 'hepatitis_c', label: 'sectionB.liver.hepatitisC', },
  { value: 'hepatitis_d', label: 'sectionB.liver.hepatitisD', },
  { value: 'fatty_liver', label: 'sectionB.liver.fattyLiver', },
  { value: 'cirrhosis', label: 'sectionB.liver.cirrhosis', },
  { value: 'other_liver_disease', label: 'sectionB.liver.otherLiverDisease', },
];
const herniaConditions = [
  { value: 'diaphragm', label: 'sectionB.hernia.diaphragm', },
  { value: 'navel', label: 'sectionB.hernia.navel', },
  { value: 'right_groin', label: 'sectionB.hernia.rightGroin', },
  { value: 'left_groin', label: 'sectionB.hernia.leftGroin', },
];

const kidneyUrinaryConditions = [
  { value: 'recurrent_infections', label: 'sectionB.kidneyUrinary.recurrentInfections', },
  { value: 'stones', label: 'sectionB.kidneyUrinary.stones', },
  { value: 'cysts', label: 'sectionB.kidneyUrinary.cysts', },
  { value: 'anomalies', label: 'sectionB.kidneyUrinary.anomalies', },
  { value: 'renal_failure', label: 'sectionB.kidneyUrinary.renalFailure', },
  { value: 'other', label: 'sectionB.kidneyUrinary.other', },
];

const jointsBonesConditions = [
  { value: 'arthritis', label: 'sectionB.jointsBones.arthritis',},
  { value: 'gout', label: 'sectionB.jointsBones.gout',},
  { value: 'back_spine', label: 'sectionB.jointsBones.backSpine',},
  { value: 'joints', label: 'sectionB.jointsBones.joints',},
  { value: 'knees', label: 'sectionB.jointsBones.knees',},
  { value: 'other', label: 'sectionB.jointsBones.other',},
];

const skinSexConditions = [
  { value: 'skin_tumors', label: 'sectionB.skinSex.skinTumors', },
  { value: 'skin_lesions', label: 'sectionB.skinSex.skinLesions', },
  { value: 'psoriasis', label: 'sectionB.skinSex.psoriasis', },
  { value: 'std', label: 'sectionB.skinSex.std', },
  { value: 'syphilis', label: 'sectionB.skinSex.syphilis', },
  { value: 'other', label: 'sectionB.skinSex.other', },
];

const entConditions = [
  { value: 'sleep_apnea', label: 'sectionB.ent.sleepApnea', },
  { value: 'nasal_polyp', label: 'sectionB.ent.nasalPolyp', },
  { value: 'sinusitis', label: 'sectionB.ent.sinusitis', },
  { value: 'other', label: 'sectionB.ent.other', },
];

const womenConditions = [
  { value: 'breasts', label: 'sectionB.women.breasts', },
  { value: 'gynecological', label: 'sectionB.women.gynecological', },
  { value: 'other_feminine_problem', label: 'sectionB.women.otherFeminineProblem', },
  { value: 'pregnant', label: 'sectionB.women.pregnant', },
  { value: 'cesarean', label: 'sectionB.women.cesarean', },
];

const menConditions = [
  {
    value: 'prostate',
    label: 'sectionB.men.prostate',
  },
  {
    value: 'varicocele',
    label: 'sectionB.men.varicocele',
  },
  {
    value: 'other_masculine_diseas',
    label: 'sectionB.men.otherMasculineDiseas',
  },
]

const genderConditions = computed(() =>
  props.gender === 'male' ? menConditions : womenConditions
);
const initialGender = ref(false);

watch(() => props.gender, (oldG,newG) => {
  if (!initialGender.value) {
    initialGender.value = true;
    return;
  }
  if (newG !== oldG) {
    form.genderCondition = {
      hasCondition: 'yes',
      conditions:[]
    };
  }
});
const onConditionChange = (section) => {
  if (form[section].conditions.length > 0) {
    form[section].hasCondition = 'yes';
  }
  clearError(`sectionB.${section}.conditions`);
};
</script>
<style scoped>
  .head-block {
    display: flex;
    align-items: center;        /* vertical alignment */
    justify-content: space-between; /* left ↔ right */
    gap: 1rem;
    margin-bottom: 1rem;
  }
  .title-help-text {
    margin-left: 8px;
    font-size: 12px;
    color: #797f8a;
    background: #f3f4f6;
    padding: 2px 6px;
    border-radius: 6px;
  }
</style>